export const selectUsers = (state) => state.users.list;
export const selectUsersLoading = (state) => state.users.loading;
export const selectUsersError = (state) => state.users.error;
export const selectUserForm = (state) => state.usersForm.form;
export const selectUserStep = (state) => state.usersForm.step;
